export const shiftEN = {
  "shiftSider": {
    "headingLabel": "Work Shift Settings",
    "information": "General information",
    "midShiftSettings": "Mid Shift Settings",
    "titleAdd" : "Create new installation of a work shift-registration",
    "titleUpdate" : "Update installation of a work shift-registration",
    "listShift": "Shift List",
  },
  "shiftTitle": {
    "codeShift": "Code shift",
    "nameSHift": "Shift name",
    "flexibleHours": "Flexible hours",
    "manyShift": "Multiple work periods ",
    "timeBreak": "Start break ",
    "endBreak": "End break",
    "checkInFirst": "Check-In first",
    "checkInLater": "Check In later",
    "totalHours": "Total hours",
    "totalWork": "Total work",
    "status": "Status",
    "workingCheck": "Calculate time for early or late arrivals",
    "overTime": "Overtime between shifts",
    "midShift": "Mandatory latch mid shift",
    "checkFirstShift": "Check out at the end of the first shift",
    "checkNextShift": "Check in for the first shift later",
    "shiftHoliday": "Automatic shift for public holidays",
    "timekeepingAuto": "Automatic timekeeping",
    "checkApplyToLocation": "Check out automatically apply to location",
    "checkByDepartmentLocation": "Automatically recognize department location",
    "noteShift": "Note",
    "timeIn": "Time in",
    "timeOut": "Time out",
    "byDay": "Cross-day shift ",
    "yes" : "Yes",
    "no" : "No",
    "department": "Department",
    "position": "Position",
    "chucvu" : "Position",
    "sbapplication" : "Applicable employees ",
    "checkInFrequency" : "Attendance tracking by check-in frequency",
    "checkinLabel" : "Minimum required check-ins",
    "checkinLabelRequire" : "Minimum check-in count is required!",
    "checkinLabelPlaceholder" : "Input the minimum number of check-ins",
    "timeBetweenCheckIn" : "Time between check-ins",
    "attendancePercentage" : "Check-in based work %",
    "attendancePercentageToolTip" : "The actual work percentage is calculated by the number of check-ins. If the required check-ins are 4 and an employee checks in 2 times, they will receive 50% of the total work credit.",
    "timekeepingAutoToolTip" : "When Enabled: Employees assigned to this shift will be automatically recorded.",
    "checkApplyToLocationToolTip" : "When enabled, employees do not need to check out at the end of the shift."
  },
  "shiftMenu": {
    "addShift": "Add New Shift",
    "editShift": "Update Shift",
    "deleteShift": "Delete Shift"
  }
}
